import Vue from 'vue'
import './plugins/vuetify'
import VeeValidate from 'vee-validate'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import { unregister } from 'register-service-worker'
import './assets/style.css'

import DefaultLayout from '@/layout/default.vue'
import LoginLayout from '@/layout/login.vue'
import ExpertLayout from '@/layout/expert.vue'
import SonkoLayout from '@/layout/sonko.vue'
import PackagesLayout from '@/layout/packages.vue'
import AppSnackbar from '@/components/global/snackbar.vue'
import * as VueGoogleMaps from "vue2-google-maps";
import vueHeadful from 'vue-headful';
import VueExcelXlsx from "vue-excel-xlsx";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueLazyLoad from 'vue-lazyload'
import VIPSonkoLayout from '@/layout/vip_sonko.vue'

unregister();

/*if('serviceWorker' in navigator) {
	window.addEventListener('load',() => {
		navigator.serviceWorker
			.register('./registerServiceWorker.js')
			.then(reg => console.log('Service worker registered'))
			.catch(err => console.log(`Service worker error: ${err}`))
	})
}*/

Vue.use(require('vue-moment'));

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAJOHz7MEJ8oFqJbWqsVgfMpEwCklH0nAw",
    components: "country:ke",
    libraries: "places" // necessary for places input
  }
});
Vue.use(VeeValidate)
Vue.component('AppSnackbar', AppSnackbar)
Vue.component('DefaultLayout', DefaultLayout)
Vue.component('LoginLayout', LoginLayout)
Vue.component('ExpertLayout', ExpertLayout)
Vue.component('SonkoLayout', SonkoLayout)
Vue.component('PackagesLayout', PackagesLayout)
Vue.component('VipSonkoLayout', VIPSonkoLayout)
Vue.component('vue-headful', vueHeadful);
Vue.use(VueExcelXlsx);
Vue.use( CKEditor );
Vue.use(VueLazyLoad);
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
